var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,9.3c0.6,1.6,2.2,5.7,4.5,9.7l1,1.7l0.9-1.8c2-4,5.8-6.5,10.2-6.5c6.3,0,11.5,5.1,11.5,11.5s-5.1,11.5-11.5,11.5 c-2.7,0-4.9-1-6.3-1.7L31,33l-0.3,1.3L29,41.4l-0.8,3.3l-6.4,0l0.7-2.8c0.8-3.6,2-8.6,3-12.8l0.1-0.5l-0.4-0.4c-0.5-0.6-1-1.3-1.5-2 l-0.4-0.5l-1.5-2L21.5,26c-0.9,5.4-5.3,9.3-10.6,9.3C4.9,35.3,0,30.4,0,24.4V9.3h6.2v15.1c0,2.6,2.1,4.7,4.7,4.7s4.7-2.1,4.7-4.7 V9.3L22,9.3L22,9.3 M38.5,29.1c2.9,0,5.2-2.3,5.2-5.2s-2.3-5.2-5.2-5.2c-2.4,0-4.5,1.6-5,3.9c0,0.1-0.4,1.6-0.8,3.2l-0.2,0.7 l0.5,0.4C35.1,28.3,36.9,29.1,38.5,29.1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwork);
export default __webpack_public_path__ + "static/media/upwork.31aff342.svg";
export { ForwardRef as ReactComponent };